export default __webpack_public_path__ + "static/media/F01a.3c6abbd0.png";